"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSplittedPaymentLines = exports.getAggregatedPaymentFees = exports.getTaxNameByID = exports.getHeaderOptionName = exports.generateDefaultReceiptSettings = exports.paymentNameFormatter = exports.capitalize = exports.formatCurrencyFromCents = exports.getWorldpayMetaDataFields = exports.getLoyaltyMetaDataFields = exports.getMonerisMetaDataFields = exports.getMerrcoMetaDataFields = exports.renderCurrency = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const lodash_1 = require("lodash");
const currency_js_1 = __importDefault(require("currency.js"));
const models_1 = require("../models");
const products_1 = require("@getgreenline/products");
function renderCurrency(cents) {
    return formatCurrencyFromCents(cents);
}
exports.renderCurrency = renderCurrency;
function getMerrcoMetaDataFields(transaction) {
    if (transaction.metadata === null) {
        return;
    }
    if (homi_shared_1.PaymentTypeIds.merrco === transaction.paymentTypeId) {
        const metaData = JSON.parse(transaction.metadata);
        return metaData;
    }
}
exports.getMerrcoMetaDataFields = getMerrcoMetaDataFields;
function getMonerisMetaDataFields(transaction) {
    if (transaction.metadata === null) {
        return;
    }
    if (homi_shared_1.PaymentTypeIds.moneris === transaction.paymentTypeId) {
        const metaData = JSON.parse(transaction.metadata);
        // if MetaData is an object from Moneris Core
        if ((0, lodash_1.isPlainObject)(metaData)) {
            const fieldsToShow = { emvLabel: '', card: '' };
            if (metaData.cardType) {
                fieldsToShow.emvLabel = metaData.cardType;
            }
            if (metaData.lastDigits) {
                fieldsToShow.card = metaData.lastDigits;
            }
            return fieldsToShow;
        }
        /**
         * MetaData may not always be an array.
         * Example (when pending transaction forced to be complete)
         * {"notes":"Forced complete","completedDate":"2020-02-13T20:20:58.081Z"}
         */
        if (!Array.isArray(metaData)) {
            return;
        }
        const fieldsToShow = { emvLabel: '', card: '' };
        metaData.forEach((field) => {
            if (field[0] === '301') {
                fieldsToShow.emvLabel = field[1];
            }
            if (field[0] === '302') {
                fieldsToShow.card = field[1].split('*').join('');
            }
        });
        return fieldsToShow;
    }
}
exports.getMonerisMetaDataFields = getMonerisMetaDataFields;
function getLoyaltyMetaDataFields(transaction) {
    if (transaction.metadata === null) {
        return;
    }
    if (homi_shared_1.PaymentTypeIds.loyalty === transaction.paymentTypeId) {
        const metaData = JSON.parse(transaction.metadata);
        return metaData;
    }
}
exports.getLoyaltyMetaDataFields = getLoyaltyMetaDataFields;
function getWorldpayMetaDataFields(transaction) {
    if (transaction.metadata === null) {
        return;
    }
    if (homi_shared_1.PaymentTypeIds.worldpay === transaction.paymentTypeId) {
        const metaData = JSON.parse(transaction.metadata);
        return metaData;
    }
}
exports.getWorldpayMetaDataFields = getWorldpayMetaDataFields;
function formatCurrencyFromCents(cents) {
    return (0, currency_js_1.default)(cents, { fromCents: true }).format();
}
exports.formatCurrencyFromCents = formatCurrencyFromCents;
const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);
exports.capitalize = capitalize;
const paymentNameFormatter = (paymentTypeId) => {
    switch (paymentTypeId) {
        case homi_shared_1.PaymentTypeIds.etransfer:
            return 'E-Transfer';
        case homi_shared_1.PaymentTypeIds.blazepay:
            return 'BLAZEPAY';
        default:
            return (0, exports.capitalize)(homi_shared_1.PaymentTypeIds[paymentTypeId]);
    }
};
exports.paymentNameFormatter = paymentNameFormatter;
const generateDefaultReceiptSettings = (company, locationId) => ({
    locationId,
    headerOption: models_1.RECEIPT_HEADER_OPTIONS.USE_COMPANY_NAME,
    header: company.name,
    subHeader: null,
    description: null,
    address: null,
    footer: null,
    showEmployee: false,
    showSku: false,
    showLoyalty: true,
});
exports.generateDefaultReceiptSettings = generateDefaultReceiptSettings;
const getHeaderOptionName = (option) => {
    switch (option) {
        case models_1.RECEIPT_HEADER_OPTIONS.USE_LOCATION_NAME:
            return 'Use location name';
        case models_1.RECEIPT_HEADER_OPTIONS.USE_CUSTOM:
            return 'Custom';
        default:
            return 'Use company name';
    }
};
exports.getHeaderOptionName = getHeaderOptionName;
const getTaxNameByID = (id) => {
    for (const [name, value] of Object.entries(products_1.TaxModels.TaxIDs)) {
        if (value === id) {
            return name;
        }
    }
    return undefined;
};
exports.getTaxNameByID = getTaxNameByID;
const getAggregatedPaymentFees = (paymentLines) => {
    return (0, lodash_1.chain)(paymentLines)
        .groupBy('productName')
        .map((obj, key) => ({
        id: key,
        name: obj[0].productName,
        totalAmount: obj.reduce((acc, cur) => acc + cur.price, 0),
    }))
        .value();
};
exports.getAggregatedPaymentFees = getAggregatedPaymentFees;
const getSplittedPaymentLines = ({ payment, paymentFeeProducts, }) => {
    const paymentLines = payment.paymentLines; // This prevents type error to use filter method
    const paymentLinesWithoutPaymentFees = paymentLines.filter((pl) => !paymentFeeProducts.find((pf) => pf.id === pl.productId));
    const paymentFeeLines = paymentLines.filter((pl) => paymentFeeProducts.find((pf) => pf.id === pl.productId));
    return {
        paymentLines: paymentLinesWithoutPaymentFees,
        paymentFeeLines,
    };
};
exports.getSplittedPaymentLines = getSplittedPaymentLines;
//# sourceMappingURL=utils.js.map